(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("shepherd.js"), require("vue"), require("vuex"), require("vxe-table"));
	else if(typeof define === 'function' && define.amd)
		define(["shepherd.js", "vue", "vuex", "vxe-table"], factory);
	else if(typeof exports === 'object')
		exports["print-template-designer"] = factory(require("shepherd.js"), require("vue"), require("vuex"), require("vxe-table"));
	else
		root["print-template-designer"] = factory(root["shepherd.js"], root["vue"], root["vuex"], root["vxe-table"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3401__, __WEBPACK_EXTERNAL_MODULE__391__, __WEBPACK_EXTERNAL_MODULE__8342__, __WEBPACK_EXTERNAL_MODULE__4734__) {
return 